// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3ey-M","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1nhHM"};